import { render, staticRenderFns } from "./ChannelDialog.vue?vue&type=template&id=0c2080ba&scoped=true&"
import script from "./ChannelDialog.vue?vue&type=script&lang=js&"
export * from "./ChannelDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDialog.vue?vue&type=style&index=0&id=0c2080ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2080ba",
  null
  
)

export default component.exports